import React from 'react';
import PropTypes from 'prop-types';
import NoSSR from 'react-no-ssr';
import { trans, getPagePath } from '@spotahome/bff/client';
import { MobileMenu, Logo } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/MobileMenu.css';

// 🚨 LEGACY COMPONENT
import LanguageSwitcherContainer from '../../LEGACY/javascripts/ui/menu/language-switcher-container';

import LoginButton from './login/LoginButton';

const MobileNav = ({ options, onClose }) => (
  <MobileMenu
    logo={
      <a href={getPagePath('landing')}>
        <Logo size="medium" />
      </a>
    }
    className="homeMobileMenu"
    onClose={onClose}
  >
    <MobileMenu.List>
      {options.includes('home') && (
        <MobileMenu.Item>
          <MobileMenu.Link
            className="ga-home"
            href={getPagePath('externals.landing-pages.home')}
          >
            {trans('landing-pages.home')}
          </MobileMenu.Link>
        </MobileMenu.Item>
      )}

      {options.includes('landlord-panel') && (
        <MobileMenu.Item>
          <MobileMenu.Link
            className="ga-landlord-panel-login"
            href={getPagePath('landlord-panel')}
          >
            {trans('landlords.login')}
          </MobileMenu.Link>
        </MobileMenu.Item>
      )}

      {options.includes('list-your-property') && (
        <MobileMenu.Item>
          <MobileMenu.Link
            href={getPagePath('externals.landing-pages.list-your-property')}
          >
            {trans('landingpage.button.landlord')}
          </MobileMenu.Link>
        </MobileMenu.Item>
      )}

      {options.includes('how-it-works') && (
        <MobileMenu.Item>
          <MobileMenu.Link
            href={getPagePath('externals.landing-pages.how-it-works')}
            target="_blank"
          >
            {trans('how_it_works.title')}
          </MobileMenu.Link>
        </MobileMenu.Item>
      )}

      {options.includes('favorites') && (
        <MobileMenu.Item>
          <MobileMenu.Link
            href={getPagePath('marketplace.favorites')}
            target="_blank"
          >
            {trans('favorites.title.favorites')}
          </MobileMenu.Link>
        </MobileMenu.Item>
      )}

      <MobileMenu.Separator />

      <NoSSR>
        <LoginButton isMobile hasDarkBackground />
      </NoSSR>

      <MobileMenu.Separator />

      <MobileMenu.Item>
        <MobileMenu.Link
          href={getPagePath('externals.landing-pages.help-center')}
        >
          {trans('help.title')}
        </MobileMenu.Link>
      </MobileMenu.Item>

      <MobileMenu.Item>
        <MobileMenu.Link>
          <LanguageSwitcherContainer />
        </MobileMenu.Link>
      </MobileMenu.Item>
    </MobileMenu.List>
  </MobileMenu>
);

MobileNav.defaultProps = {
  options: ['home', 'list-your-property', 'how-it-works', 'favorites'],
  onClose: () => {}
};

MobileNav.propTypes = {
  onClose: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.oneOf(['home', 'list-your-property', 'how-it-works', 'favorites'])
  )
};

export default MobileNav;
